// Matters (parts/Matters.body): the durable unit (D102); a title is never renamed, it gets
// an alias; one owner, a priority, a tier (module 08 rule 9).
import { useState } from 'react';
import { records, type MatterFilter } from '../api.js';
import { formatDate } from '../labels.js';
import { Count, Empty, Facet, Failed, Foot, Heading, Loading, matterKindWord, Pill, RowLink, useLoad, whenWord, type PageProps } from './shared.js';

export function Matters({ store, open }: PageProps) {
  const [filter, setFilter] = useState<MatterFilter>('open_mine');
  const [kind, setKind] = useState('');
  const [state] = useLoad(() => records.matters(store.tenantId, { filter, kind }), [store.tenantId, filter, kind]);
  const counts = state.kind === 'ready' ? state.data.counts : null;
  return (
    <div className="recs">
      <Heading title="Matters" line={<>
        <Count n={counts?.openMine}>open and yours</Count>
        <Count n={counts?.openAll}>open in all you may see</Count>
      </>} />
      <div className="filters">
        <div className="chips">
          <span className="chips-l">Show</span>
        <Pill on={filter === 'open_mine'} onClick={() => setFilter('open_mine')} n={counts?.openMine}>Open, mine</Pill>
        <Pill on={filter === 'open_all'} onClick={() => setFilter('open_all')} n={counts?.openAll}>Open, all I may see</Pill>
        <Pill on={filter === 'parked'} onClick={() => setFilter('parked')} n={counts?.parked}>Parked</Pill>
        <Pill on={filter === 'closed'} onClick={() => setFilter('closed')} n={counts?.closed}>Closed</Pill>
        <Facet label="By kind" value={kind} options={state.kind === 'ready' ? state.data.kinds : []} onChange={setKind} />
        </div>
      </div>
      {state.kind === 'loading' ? <Loading what="the matters" /> : state.kind === 'error' ? <Failed message={state.message} /> : (
        <div className="scroll"><table className="rec">
          <thead><tr><th>Matter</th><th>Kind</th><th>Counterparty</th><th>Owner</th><th>Tier</th><th className="num">Priority</th><th>Due</th><th className="num">Open commitments</th><th>Last movement</th></tr></thead>
          <tbody>
            {state.data.matters.length === 0
              ? <Empty cols={9} head="No matter under that." says="Choose another filter. A matter is the durable thing a run of conversations is about; Cobrain opens one when it can see the same subject running across them." />
              : null}
            {state.data.matters.map((m) => (
              <tr key={m.id} className="row-open" onClick={() => open(`/matters/${m.id}`)}>
                <td><b><RowLink to={`/matters/${m.id}`} open={open}>{m.displayAlias ?? m.title}</RowLink></b>{m.aliases.length ? <> <span className="note">alias: {m.aliases.join(', ')}</span></> : null}</td>
                <td>{matterKindWord(m.kind)}</td>
                <td>{m.counterpartyName ? <RowLink className="dotted" to={`/companies/${m.counterpartyId}`} open={open}>{m.counterpartyName}</RowLink> : <span className="note">none yet</span>}</td>
                <td>{m.ownerName ?? m.ownerPrincipalId}</td>
                <td>{m.domainTier}</td>
                <td className="num">{m.priority}</td>
                <td>{m.dueAt ? formatDate(m.dueAt) : ''}</td>
                <td className="num">{m.openCommitments}</td>
                <td>{whenWord(m.lastMovementAt)}{m.lastMovementSignals > 0 ? `, ${m.lastMovementSignals} item${m.lastMovementSignals === 1 ? '' : 's'} linked` : ''}</td>
              </tr>
            ))}
{/* BUGS.md D120: the rows the filter matches, of which the list holds the first five hundred. */}
<Foot cols={9} offset={0} limit={state.data.matters.length} total={state.data.total ?? state.data.matters.length} onPage={null} />
          </tbody>
        </table></div>
      )}
    </div>
  );
}
